module.exports = __webpack_public_path__ + "static/media/home1-min.01dd88a2.jpg";